var _path, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntrusionicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9231 16.7209C44.1385 16.7209 46.7692 14.0837 46.7692 10.8605C46.7692 7.63721 44.1385 5 40.9231 5C37.7077 5 35.0769 7.63721 35.0769 10.8605C35.0769 14.0837 37.7077 16.7209 40.9231 16.7209ZM30.1077 26.6837L21.9231 68H28.0615L33.3231 44.5581L39.4615 50.4186V68H45.3077V46.0233L39.1692 40.1628L40.9231 31.3721C44.7231 35.7674 50.5692 38.6977 57 38.6977V32.8372C51.4462 32.8372 46.7692 29.907 44.4308 25.8047L41.5077 21.1163C40.3385 19.3581 38.5846 18.186 36.5385 18.186C35.6615 18.186 35.0769 18.4791 34.2 18.4791L19 24.9256V38.6977H24.8462V28.7349L30.1077 26.6837Z",
    fill: "#C7C7D6"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.8214,
    y1: 2.80758,
    x2: 58.6214,
    y2: 71.2076,
    stroke: "#C7C7D6",
    strokeWidth: 3.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntrusionicon);
export default __webpack_public_path__ + "static/media/intrusionicon.61542f7bf5da5e5d63aa29a98ed620a7.svg";
export { ForwardRef as ReactComponent };